import GeaoLayout from "../shared/Layout/GeaoLayout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { GeaoPaths } from "../../constants/GeaoPaths";
import { VerificationMethods } from "./RecallHelpers";
import { sendOtpText, sendOtpEmail } from "../../../../api/otp";
import { ClientConfigurationContext } from "../../../../context/ClientConfigurationContextProvider";

const validationSchema = yup.object().shape({

});

export default function RecallSendCode() {
    const location = useLocation();
    const clientConfiguration = useContext(ClientConfigurationContext);
    const enableOffshore = clientConfiguration?.enableOffshore === true;
    const isOffshoreResident = enableOffshore && location.state?.offshoreResident === true;

    const { register, handleSubmit, setValue } = useForm({
        defaultValues: {
            verificationMethod: isOffshoreResident ? VerificationMethods.Email : undefined,
        },
        resolver: yupResolver(validationSchema)
    });

    useEffect(() => {
        if (isOffshoreResident) {
            setValue("verificationMethod", VerificationMethods.Email);
        }
    }, [isOffshoreResident, setValue]);

    const navigate = useNavigate();
    const [maskedPhoneNumber] = useState(location.state?.maskedPhoneNumber);
    const [maskedEmailAddress] = useState(location.state?.maskedEmailAddress);
    const [buttonsDisabled, setButtonsDisabled] = useState(false);

    const onSubmit = (values) => {
        let verificationValue = undefined;

        const successCallback = (response) => {
            navigate(GeaoPaths.RecallVerification, {
                state: {
                    method: values.verificationMethod,
                    verificationValue: verificationValue,
                    otpData: response,
                }
            });
        }

        if (values.verificationMethod === VerificationMethods.Text) {
            setButtonsDisabled(true);
            verificationValue = maskedPhoneNumber;
            sendOtpText(
                successCallback,
                () => { },
                () => { setButtonsDisabled(false); }
            );
        } else if (values.verificationMethod === VerificationMethods.Email) {
            setButtonsDisabled(true);
            verificationValue = maskedEmailAddress;
            sendOtpEmail(
                successCallback,
                () => { },
                () => { setButtonsDisabled(false); }
            );
        } else {
            return;
        }
    }

    return (
        <GeaoLayout header="Verification">
            <form className="form geao-form" onSubmit={handleSubmit(onSubmit)} style={{ width: "750px" }} >
                <h2 className="margin-bottom">
                    Welcome back. Let's get you verified.
                </h2>

                <fieldset
                    className="form-field radio-button-group"
                    aria-label="Where should we send your verification code?"
                >
                    {!isOffshoreResident &&
                        <legend>
                            Where should we send your verification code?
                        </legend>
                    }
                    <div className="radio-button-wrapper col-1">
                        {!isOffshoreResident &&
                            <div className="label--description">
                                <input data-onboarding-radio-id="Recall:RecallSendCode:VerificationMethod"
                                    data-onboarding-option-id="Text"
                                    id="radio-phone-number"
                                    type="radio"
                                    name="radio-phone-number"
                                    value={VerificationMethods.Text}
                                    {...register("verificationMethod")}
                                />
                                <label className="radio" htmlFor="radio-phone-number">
                                    <span>
                                        Text
                                        <span>
                                            {maskedPhoneNumber}
                                        </span>
                                    </span>
                                </label>
                            </div>
                        }

                        <div className="label--description">
                            <input data-onboarding-radio-id="Recall:RecallSendCode:VerificationMethod"
                                data-onboarding-option-id="Email"
                                id="radio-email"
                                type="radio"
                                name="radio-email"
                                value={VerificationMethods.Email}
                                {...register("verificationMethod")}
                            />
                            <label className="radio" htmlFor="radio-email">
                                <span>
                                    Email
                                    <span>
                                        {maskedEmailAddress}
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                </fieldset>

                <div className="flex-row">
                    <div className="col-sm-12">
                        <button data-onboarding-button-id="Recall:RecallSendCode:Continue"
                            type="submit"
                            className="btn btn--primary btn--full-mobile btn--pull-right"
                            disabled={buttonsDisabled}
                        >
                            <span>Continue</span>
                        </button>
                    </div>
                </div>
            </form>
        </GeaoLayout>
    );
}
